import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import Spinner from '../../components/generics/Spinner';
import DetailHeader from '../../components/generics/DetailHeader';
import SelectableInventoryTable from '../../components/generics/SelectableInventoryTable';

import { fetchReturn, fetchReturnSuccess, fetchReturnFailure } from "../../store/shipments/actions";
import { withRouter } from "utils/WithRouter";

export class ReturnDetailContainer extends Component {
  constructor(props){
    super(props);
    this.state = {is_possible_add_inventories: true};
  }

  componentDidMount(){
    this.props.fetchReturn(this.props.match.params.id);
  }

  addInventory = () => {
    this.props.history.push('/return/' + this.props.match.params.id + '/add_inventory');
  };

  componentDidUpdate(prevProps) {
    const { returnDetail } = this.props;
    const { returnDetail: oldReturnDetail } = prevProps;

    if (oldReturnDetail.returnDetail !== returnDetail.returnDetail) {
      const is_possible_add_inventories = this.check_if_possible_add_inventory(returnDetail.returnDetail.added_to_inventory, returnDetail.returnDetail.inventory_details)
      this.setState({is_possible_add_inventories})
    }
  }

  check_if_possible_add_inventory = (added_to_inventory, inventory_details) => {
    const total_added = added_to_inventory.reduce((acc, inventory) => {return acc + inventory.number_items}, 0)
    const total_details= inventory_details.reduce((acc, inventory) => {return acc + inventory.number_items}, 0)
    return total_added < total_details
  }

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render(){

      if (!this.props.returnDetail.returnDetail){
        return (<Spinner />);
      } else {
          return (
            <div className="animated fadeIn return">
              <DetailHeader title="Return"
                            actionTitle="Add Inventory"
                            actionClass="btn btn-success m-0"
                            action={this.addInventory}
                            hideAction={!this.state.is_possible_add_inventories}
                            col1Title="Shipment ID"
                            col1Desc={this.props.returnDetail.returnDetail.shipment}
                            col1Link={`/shipment/${this.props.returnDetail.returnDetail.shipment}`}
                            col2Title="Return Date"
                            col2Desc={moment(this.props.returnDetail.returnDetail.created_at).format('LLL')}
                            col3Title="Customer"
                            col3Desc={this.props.returnDetail.returnDetail.shipment_data.destination.name}
                            col4Title="Category"
                            col4Desc={this.props.returnDetail.returnDetail.return_category_data ? this.props.returnDetail.returnDetail.return_category_data.name : '-'}/>
              <SelectableInventoryTable list={this.props.returnDetail.returnDetail.inventory_details}
                                      tableTitle="Returned items"
                                      showCostPrice={true}
                                      readOnly={true} />
              <SelectableInventoryTable list={this.props.returnDetail.returnDetail.added_to_inventory}
                                        tableTitle="Added to inventory"
                                        readOnly={true}
                                        showCostPrice={true}
                                        emptyListMessage="There are no returned items added to the inventory yet" />
            </div>
        );
      }
    }
  }

const mapStateToProps = (state, ownProps) => {
  return {
    returnDetail: state.shipments.returnDetail,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchReturn: (id) => {
      dispatch(fetchReturn(id)).payload.then((response) => {
        dispatch(fetchReturnSuccess(response.data));
      }, (error) => {
        dispatch(fetchReturnFailure(error));
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReturnDetailContainer));
